module.exports = __webpack_public_path__ + "img/plus.b91742da.svg";